import { Component, type ErrorInfo, type ReactNode } from "react";
import { AlertCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { logger } from "@/lib/logger";

interface Props {
  children: ReactNode;
  title?: string;
}

interface State {
  error: Error | null;
}

/** Contiene fallos de render de una sección para no tumbar la app completa. */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    logger.warn("[UI] Error de render contenido:", error.message, info.componentStack);
  }

  private reset = () => this.setState({ error: null });

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="grid min-h-64 place-items-center rounded-md border border-border bg-card text-center">
        <div className="space-y-3 p-6">
          <AlertCircle className="mx-auto size-8 text-destructive" />
          <div>
            <p className="font-medium">{this.props.title ?? "No se pudo mostrar esta sección"}</p>
            <p className="max-w-sm text-sm text-muted-foreground">
              Ocurrió un problema al construir la vista con los datos recibidos.
            </p>
          </div>
          <Button variant="outline" size="sm" onClick={this.reset}>
            Reintentar
          </Button>
        </div>
      </div>
    );
  }
}
